import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function loadView(view) {
  return (resolve) => require([`../views/${view}.vue`], resolve); //() => import(`../pages/${box}/${view}.vue`);
};
export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: loadView('index'),
    }, {
      path: '/trading',
      name: 'trading',
      component: loadView('trading'),
    }, {
      path: '/guide',
      name: 'guide',
      component: loadView('guide'),
    },  {
      path: '/contactUs',
      name: 'contactUs',
      component: loadView('contactUs'),
    }, {
      path: '/about',
      name: 'about',
      component: loadView('about'),
      redirect: '/about/who', // 重定向
      children: [
        {
          path: 'who',
          name: 'who',
          component: (resolve) => require(['../views/components/who'], resolve),
          meta:{navIndex:0}
        }, {
          path: 'why',
          name: 'why',
          component: (resolve) => require(['../views/components/whyUs'], resolve),
          meta:{navIndex:1}
        }, 
        {
          path: 'nfa',
          name: 'nfa',
          component: (resolve) => require(['../views/components/Nfa'], resolve),
          meta:{navIndex:2}
        }, 
      ]
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js